import { FC } from 'react';
import { cn } from 'shared/utils/cn.ts';
import { LoadingSpinner, LoadingSpinnerProps } from './LoadingSpinner.tsx';

export const FullPageLoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 48, className = '' }) => {
  return (
    <div className={cn('flex h-full w-full items-center justify-center', className)}>
      <LoadingSpinner size={size} />
    </div>
  );
};
